export interface IContainerTreeViewProps<T> {
	children: JSX.Element;
	data: string;
	datas: string[];
	deeper: number;
	id: string;
	index: string;
	idElement: number;
	isChildrenOfChannel: string;
	isChildrenOfFamily: string;
	channelRepresentative: string;
	original: any;
	isOpen: boolean;
	extra?: T;
}
export type ITreeViewContainersProps<T> = Array<
	(props: IContainerTreeViewProps<T>) => JSX.Element
>;

export interface IItemTreeView {
	index: string;
	data: string;
	isOpen: boolean;
	children: Array<string>;
	hasChildren: boolean;
	original: any;
	[key: string]: any;
}
export type IItemsTreeView = Record<string, IItemTreeView>;
export interface ITreeViewProps<T> {
	items: IItemsTreeView;
	id: string;
	Containers: ITreeViewContainersProps<T>;
	ids: string[];
	deeper: number;
	ortiginal?: any;
	filter?: any;
}

export default function TreeView<T>({
	Containers,
	items,
	id,
	ids,
	deeper,
	filter,
}: ITreeViewProps<T>) {
	const Container = Containers[items[id].indexComponent];
	return (
		<Container
			data={items[id].data}
			datas={ids}
			deeper={deeper}
			id={id}
			index={items[id].index}
			idElement={items[id].id}
			isChildrenOfChannel={items[id].isChildrenOfChannel}
			isChildrenOfFamily={items[id].isChildrenOfFamily}
			channelRepresentative={items[id].channelRepresentative}
			extra={items[id].extra}
			original={items[id].original}
			isOpen={items[id].isOpen}
		>
			<>
				{items[id].children.map((id: string) => (
					<TreeView
						ids={[...ids, items[id].index]}
						key={id}
						Containers={Containers}
						items={items}
						id={id}
						deeper={deeper + 1}
						filter={filter}
					/>
				))}
			</>
		</Container>
	);
}
